export default __webpack_public_path__ + "static/media/World_fire.cfbfc5f0.png";